import { Card } from 'antd';
import Container from '../../components/Container';
import UserValueCardTable from '../../components/users/userDetail/UserValueCardTable';

const ValueCardList = () => {
  return (
    <Container>
      <Card>
        <UserValueCardTable />
      </Card>
    </Container>
  );
};

export default ValueCardList;
